@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent content">
    <irb-editor-sidebar-banner
      [accordian]="accordian"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified"
      [isValid]="isValid"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      [(saveLabel)]="saveLabel"
      [isSaveEnable]="!isReadOnly"
      (save)="saveRebalance()"
      (cancel)="closeWithCheck()"><span header class="ms-header" tooltip [tooltipTitle]="rebalanceTitle" [tooltipRequiresTruncation]="true">{{rebalanceTitle}}</span></irb-editor-sidebar-banner>
      <div class="body" [style.height]="bodyHeight" #body>
        @if (data && !isUnitTest) {
          <rebalance-general-info [(data)]="data" [isReadOnly]="summarySource==='resultSummary'" (change)="onInputChange();" [ignoreUnsavedChanges]="ignoreUnsavedChanges"></rebalance-general-info>
        }
        <mat-accordion #accordian="matAccordion" [multi]="true">
          <mat-expansion-panel id="fullRebalance_Setting"
            [expanded]="ies.getDefaultExpansionState('fullRebalance_Setting')"
            (opened)="ies.updateExpansionState('fullRebalance_Setting','opened')"
            (closed)="ies.updateExpansionState('fullRebalance_Setting','closed')"
            disabled>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <strong> Rebalance settings</strong>
                <p style="margin-left: 50px; font-weight: 400; font-size: 13px;">No rebalance settings are needed for this rebalance type.</p>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
            </ng-template>
          </mat-expansion-panel>
          <!--included poerfolio-->
          @if (!isSchedulerRemove) {
            <mat-expansion-panel id="fullRebalance_included_portfilio"
              [expanded]="ies.getDefaultExpansionState('fullRebalance_included_portfilio')"
              (opened)="ies.updateExpansionState('fullRebalance_included_portfilio','opened')"
              (closed)="ies.updateExpansionState('fullRebalance_included_portfilio','closed')" #includedPortfolioPanel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Included Portfolios
                  <span class="included-portfolios-panel-text"><span class="counter-text">{{getPortfolioCount()}}</span>
                  @if (!includedPortfolioPanel?.expanded && !(this.data && this.data.isUIAllPort && this.data.isUIAllPort == true)) {
                    <span class="extra-cash-text">(<i>Expand this container to add Extra Cash settings.</i>)</span>
                  }
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data!='undefined' && !isUnitTest) {
                <included-portfolio #includedportfolio [data]="data" (dataChange)="smartFilterChange($event)"></included-portfolio>
              }
            </ng-template>
          </mat-expansion-panel>
        }
        <!--Scheduler-->
        @if (!isSchedulerRemove) {
          <mat-expansion-panel id="fullRebalance_scheduler"
            [expanded]="ies.getDefaultExpansionState('fullRebalance_scheduler')"
            (opened)="ies.updateExpansionState('fullRebalance_scheduler','opened')"
            (closed)="ies.updateExpansionState('fullRebalance_scheduler','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Schedule
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data && !isUnitTest) {
                <rebalance-scheduler [(data)]="data" [(scheduler)]="data.scheduler" (change)="onInputChange();"></rebalance-scheduler>
              }
            </ng-template>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
}
